export function classesSubtitle(classes: readonly { subjects: readonly string[] }[]): string {
  const count = `${classes.length} classe${classes.length !== 1 ? 's' : ''}`
  const subjects = [...new Set(classes.flatMap((c) => c.subjects).map((s) => s.trim()).filter(Boolean))]
  return subjects.length > 0 ? `${count} · ${subjects.join(', ')}` : count
}
